module.exports = __webpack_public_path__ + "img/4-01-02-a.2c3dc43e.svg";